// INDEX
export const ROOT = '';
export const INDEX = '/';


export const CATALOG = '/catalog';
export const CATEGORY = '/catalog/:id';

export const COLLECTION = '/collection/:id';
export const toCollectionId = (id:string) => `/collection/${id}`;

export const CANDLES = '/catalog/candles';
export const HANDLER = '/catalog/handler';
export const DINNER = '/catalog/dinner';
export const INTERIOR = '/catalog/interior';
export const DIFFUSER = '/catalog/diffuser';

export const PRODUCT = '/product/:id';
export const toProductId = (id:string) => `/product/${id}`;

export const CART = '/cart';
export const ORDER = '/order/:id';
export const toOrderId = (id: string) => `/order/${id}`;
export const PAYMENT_CHECK = '/payment/:id';
export const toPaymentId = (id: string) => `/payment/${id}`;
export const SUCCESS = '/success';

export const CONTACT = '/contact';
export const DELIVERY = '/delivery';

export const DOC_POLICY = '/docs/daisy_policy.pdf';
export const DOC_OFFER = '/docs/daisy_offer.pdf';

export const LINK_PINTEREST = 'https://pin.it/1QW4cxlsW';
export const LINK_TELEGRAM = 'https://t.me/+qWXrmTVLWNAwY2E6';
export const LINK_INSTAGRAM = '@daisy_candles_store';